import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "no-resource-body-wrap flex-col" }
const _hoisted_2 = { class: "no-resource-row" }
const _hoisted_3 = { class: "text-sm" }

import ButtonCustom from '@/components/elements/ButtonCustom';
import useAddCardsToInEpicBoard from '@/utilities/composables/useAddCardsToInEpicBoard';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'InEpicBoardNoResourceBody',
  props: {
  currentBoardId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { openQuickCard, openFindCard } = useAddCardsToInEpicBoard(props.currentBoardId);
const { translate } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(translate)('addCardsThatContributeToProject')), 1)
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(["no-resource-row", { 'flex-col': _ctx.isMobile }])
    }, [
      _createVNode(_unref(ButtonCustom), {
        class: "pointer-events-auto",
        type: "important-custom",
        text: _unref(translate)('addNewCard').toLowerCase(),
        "custom-icon-name": 'plus',
        "custom-icon-size": '16px',
        onClick: _unref(openQuickCard)
      }, null, 8, ["text", "onClick"]),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("span", null, _toDisplayString(_unref(translate)('or').toLowerCase()), 1),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createVNode(_unref(ButtonCustom), {
        class: "pointer-events-auto",
        type: "important-custom",
        text: _unref(translate)('addExistingCard').toLowerCase(),
        "custom-icon-name": 'search-alternative',
        "custom-icon-size": '16px',
        onClick: _unref(openFindCard)
      }, null, 8, ["text", "onClick"])
    ], 2)
  ]))
}
}

})